import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl text-accent-400 mb-4">
              虫虫动漫
            </h4>
            <p className="text-sm text-secondary-300 leading-relaxed">
              虫虫动漫提供免费漫画与免费看漫画在线平台，海量免费动漫全集免费阅读，下拉式滚动浏览让您畅享免费漫画网站大全，无需付费轻松看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  漫画分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/shounen" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  少年热血
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  恋爱校园
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  奇幻冒险
                </Link>
              </li>
              <li>
                <Link to="/category/suspense" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  悬疑推理
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <p className="text-sm text-secondary-300 leading-relaxed">
              如果您有任何问题或建议，欢迎通过关于我们页面的联系方式与我们取得联系。
            </p>
            <div className="flex gap-3 mt-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 虫虫动漫 - 免费漫画在线阅读平台。本站所有漫画均为免费阅读。
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-accent-400 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-secondary-400 hover:text-accent-400 transition-colors" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}